var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{class:("icon icons_" + _vm.activeIcon + " " + (_vm.active ? 'active' : ''))},[_c('use',{attrs:{"xlink:href":("#" + _vm.activeIcon)}})])}
var staticRenderFns = []

export { render, staticRenderFns }